import { render } from "./ViewReportPage.vue?vue&type=template&id=04ab4ce8&scoped=true"
import script from "./ViewReportPage.vue?vue&type=script&lang=js"
export * from "./ViewReportPage.vue?vue&type=script&lang=js"

import "./ViewReportPage.vue?vue&type=style&index=0&id=04ab4ce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ab4ce8"]])

export default __exports__